var _circle, _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGroupPhoto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#11AB96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7227 3.83984V11.7246C12.7227 11.9226 12.5622 12.083 12.3643 12.083H4.47949C4.47949 12.4789 4.80041 12.7998 5.19629 12.7998H12.3643C12.9581 12.7998 13.4395 12.3185 13.4395 11.7246V4.55664C13.4395 4.16077 13.1186 3.83984 12.7227 3.83984Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1597 3.5939V10.4862C12.1597 11.0572 11.6968 11.5201 11.1259 11.5201H4.23355C3.66258 11.5201 3.19971 11.0572 3.19971 10.4862V3.5939C3.19971 3.02293 3.66258 2.56006 4.23355 2.56006H11.1259C11.6968 2.56006 12.1597 3.02293 12.1597 3.5939ZM8.02432 8.27723L9.50272 6.79538C9.56789 6.7306 9.65623 6.69452 9.74812 6.69516C9.84001 6.69581 9.92783 6.73313 9.99208 6.79883L11.4705 8.27723V3.5939C11.4705 3.40358 11.3162 3.24929 11.1259 3.24929H4.23355C4.04323 3.24929 3.88894 3.40358 3.88894 3.5939V8.96646L6.06001 6.79883C6.19443 6.66521 6.41151 6.66521 6.54592 6.79883L8.02432 8.27723Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03955 4.79984C7.03955 4.26965 7.46936 3.83984 7.99955 3.83984C8.25416 3.83984 8.49834 3.94099 8.67837 4.12102C8.85841 4.30106 8.95955 4.54524 8.95955 4.79984C8.95955 5.33004 8.52974 5.75984 7.99955 5.75984C7.46936 5.75984 7.03955 5.33004 7.03955 4.79984ZM7.67955 4.79984C7.67955 4.97657 7.82282 5.11984 7.99955 5.11984C8.17628 5.11984 8.31955 4.97657 8.31955 4.79984C8.31955 4.62311 8.17628 4.47984 7.99955 4.47984C7.82282 4.47984 7.67955 4.62311 7.67955 4.79984Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5756_9615",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 2,
    height: 3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03955 4.79984C7.03955 4.26965 7.46936 3.83984 7.99955 3.83984C8.25416 3.83984 8.49834 3.94099 8.67837 4.12102C8.85841 4.30106 8.95955 4.54524 8.95955 4.79984C8.95955 5.33004 8.52974 5.75984 7.99955 5.75984C7.46936 5.75984 7.03955 5.33004 7.03955 4.79984ZM7.67955 4.79984C7.67955 4.97657 7.82282 5.11984 7.99955 5.11984C8.17628 5.11984 8.31955 4.97657 8.31955 4.79984C8.31955 4.62311 8.17628 4.47984 7.99955 4.47984C7.82282 4.47984 7.67955 4.62311 7.67955 4.79984Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5756_9615)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroupPhoto);
export default __webpack_public_path__ + "static/media/icGroupPhoto.1a501aa1c8f090f26c5c5607b2aebf62.svg";
export { ForwardRef as ReactComponent };